import React from 'react'

import clsx from 'clsx'

import Card from 'components/Card'

import classes from './Banner.module.scss'

/** @type {import("./types").default} */
const Banner = ({ children, className }) => (
  <Card className={clsx('Banner', classes.root, className)} elevation={1}>
    {children}
  </Card>
)

export default Banner
